import React from "react";
import { createRoot } from "react-dom/client";
import CausalDashboard from "./interface/dashboard";
import "./styles.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<CausalDashboard />
	</React.StrictMode>,
);
